import { useSelector } from "react-redux";

import { useStoreContext } from "@components/store/provider";

import MainTaxonBanner from "@sharedComponents/banner/main-taxon-banner/";
import SubCategoryTaxonCarousel from "@sharedComponents/banner/sub-category-taxon-carousel/";

import { getMenu } from "@store/selectors/menu";

import { ALL_SUBCATEGORY_CODE } from "@constants/routes";

const ProductListingBanner = () => {
  const menu = useSelector(getMenu);

  const { category, subCategory } = useStoreContext();

  const parentCategory = menu.children?.find((menuItem) => menuItem.code === category) || {
    children: [],
  };
  const subCategories = parentCategory.children;
  const subCategoryItem = subCategories.find((menuItem) => menuItem.code === subCategory) || {};
  return subCategory === ALL_SUBCATEGORY_CODE ? (
    <SubCategoryTaxonCarousel subCategories={subCategories} />
  ) : (
    <MainTaxonBanner item={subCategoryItem} />
  );
};

export default ProductListingBanner;
